import { requestApolloConfig } from '@/api/common'
import { locate, query, xenv } from '@didi/webx-js'
import { requestHomePageApi } from '@/api/home'
import store from '@/store'
import { getPopList } from '@/pages/train-detail/components/privacy/api'
import { getStorage } from '@/utils/storage'

async function initHomeApollo({ commit }) {
  const { data, success, code } = await requestApolloConfig({
    key: 'home'
  }) || {}
  if (!success) return
  if (Number(code) !== 0) return
  const { home } = data
  commit('setHomeApolloData', home)
}

async function initHomePageData({ commit }) {
  let locationInfo = {}
  const { is_from_welfare_center } = query()
  locate?.({ useQuickOption: 'city' })
    ?.then(res => {
      locationInfo = res
    })
    ?.catch((err) => {
      console.log('首页接口调用失败', err)
    })
    ?.finally(async () => {
      const { data, success, code } = await requestHomePageApi({
        is_from_welfare_center,
        city_id: locationInfo?.cityId ?? -1
      }) || {}
      if (!success) return
      if (Number(code) !== 0) return
      commit('setHomePageData', data)
    })
}

async function initBaichuanTrainPrivacy({ commit }) {
  const token = getStorage('token') || getStorage('userInfo')?.token
  const scene = 'customer_train' // 百川配置的业务场景
  const caller = 'customer_train_toc' // 前端调用接口时自定义的独特id
  const appidMap = {
    alimp: 35023,
    wxmp: 35009,
    passenger: 10000,
    h5: 10000
  }
  const appid = appidMap[xenv()]
  const ret = await getPopList({
    appid,
    token,
    caller,
  })
  const {
    scene_map = {},
    doc_map = {},
  } = ret?.data || {}
  const privacyList = doc_map[scene_map[scene]] || {}
  commit('setBaichuanTrainPrivacy', privacyList)
}

export default {
  initHomeApollo,
  initHomePageData,
  initBaichuanTrainPrivacy
}
